import { useId } from 'react';
import { LiksSwitch } from '../../../components/liks/LiksSwitch/LiksSwitch';
import { useI18n } from '../../../i18n/useI18n';
import { ChatbotSettingsCardFooter } from './ChatbotSettingsCardFooter';

type ChatbotPublicAccessCardProps = {
  isPublic: boolean;
  isDirty: boolean;
  isSaving: boolean;
  discardLabel: string;
  saveLabel: string;
  onPublicChange: (value: boolean) => void;
  onDiscard: () => void;
  onSave: () => void;
};

export function ChatbotPublicAccessCard({
  isPublic,
  isDirty,
  isSaving,
  discardLabel,
  saveLabel,
  onPublicChange,
  onDiscard,
  onSave,
}: ChatbotPublicAccessCardProps) {
  const { translate } = useI18n();
  const publicSwitchId = useId();

  return (
    <div className="chatbot-settings__card">
      <div className="chatbot-settings__body">
        <h2 className="chatbot-settings__title">
          {translate('chatbots.settings.public.title')}
        </h2>

        <div className="chatbot-settings__switch-row">
          <LiksSwitch
            id={publicSwitchId}
            checked={isPublic}
            aria-label={translate('chatbots.settings.public.isPublicLabel')}
            disabled={isSaving}
            onChange={onPublicChange}
          />
          <label
            className="chatbot-settings__switch-label"
            htmlFor={publicSwitchId}
          >
            {translate('chatbots.settings.public.isPublicLabel')}
          </label>
        </div>
      </div>

      <ChatbotSettingsCardFooter
        isDirty={isDirty}
        isSaving={isSaving}
        isSaveDisabled={!isDirty || isSaving}
        discardLabel={discardLabel}
        saveLabel={saveLabel}
        onDiscard={onDiscard}
        onSave={onSave}
      />
    </div>
  );
}
